import styled from '@emotion/styled'
import {
  PanelStyles,
  baseAccordionContainer,
  baseAccordionHeader,
} from '../styles/Panel.styles'
import { HeaderLarge600Style } from '../../../styles/Text.styles'
import theme from '../../../styles/theme'

export const AccordionContainer = styled.div`
  ${baseAccordionContainer}
  gap: 10px;
`

export const PanelContainer = styled.div`
  ${PanelStyles}
  box-shadow: ${theme.shadows.light};
  background-color: ${(props) => props.color || 'white'} !important;
`

export const HeaderText = styled.span`
  ${HeaderLarge600Style}
  color: ${theme.colors.textWhite};
  background-color: ${`${theme.colors.second}DA`};
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
`

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 1rem;
  &:hover {
    background-color: ${theme.colors.secondaryVeryVeryLight};
    border-radius: 50%;
  }
  svg {
    width: 1rem;
    height: 1rem;
    color: ${theme.colors.secondHighlight};
  }
`

export const PanelHeader = styled.div`
  ${baseAccordionHeader}
  background-color: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
`
